import { COOKIE_VISITOR_ID } from '@marketplace/config/cookie.js'
import Cookies from 'js-cookie'

export const USER_IDENTIFY_TRAITS = () => {
    return {
        id: window.Store.accountId,
        name: window.Store.accountName,
        createdAt: window.Store.accountCreatedAt,
        type: window.Store.accountType,
        locale: window.Store.locale,
        realUserId: window.Store.userId,
        accountId: window.Store.accountId,
        visitorCookieId: Cookies.get(COOKIE_VISITOR_ID) || 'systemUser',
        experimentGroup: window.Store?.experimentGroup,
    }
}
